import { createStructuredSelector } from 'reselect';
import { selectCsrBusinessFunction, selectAdvisors, mapData } from '../../../../../selectors/globalSelectors';
import {
  fetchRAGState,
  selectGrantPurposeName,
  selectGrantRecognition,
  selectEditMode,
  selectSelectedCharityName
} from './RecommendGrantPageSelectors';
import {
  selectPurposeId,
  selectAdditionalComments,
  selectMissionaryName,
  selectEventName,
  selectMissionaryLocation,
  selectProjectName,
  selectPurposeCertification,
  selectStandardLanguage,
  selectHonorOf,
  selectMemoryOf,
  selectNotifyFirstName,
  selectNotifyLastName,
  selectThirdParty,
  selectIncludeAdvisorInfo,
  selectPublishName,
  selectAccountName,
  selectCharityId,
  selectCharityAddress
} from './ConfirmationPageSelectors';

const selectGrantPurposeDropdown = (state) => {
  const { grantPurposeDropdown } = fetchRAGState(state);
  return grantPurposeDropdown;
};

const selectGrantPurposeLoading = (state) => {
  const { grantPurpose } = fetchRAGState(state);
  return grantPurpose.isLoading;
};

export const purposeRecognitionDerivedStates = createStructuredSelector({
  grantPurposeData: selectGrantPurposeDropdown,
  grantPurposeLoading: selectGrantPurposeLoading,
  grantPurposeId: selectPurposeId,
  grantPurposeName: selectGrantPurposeName,
  purposeComments: selectAdditionalComments,
  missionaryName: selectMissionaryName,
  eventName: selectEventName,
  missionaryLocation: selectMissionaryLocation,
  projectName: selectProjectName,
  purposeCertification: selectPurposeCertification,
  standardLanguage: selectStandardLanguage,
  recognitionId: selectGrantRecognition,
  honorOf: selectHonorOf,
  memoryOf: selectMemoryOf,
  notifyFirstName: selectNotifyFirstName,
  notifyLastName: selectNotifyLastName,
  advisorThirdPartyComment: selectThirdParty,
  includeAdvisorInfo: selectIncludeAdvisorInfo,
  permissionToPublish: selectPublishName,
  accountName: selectAccountName,
  editMode: selectEditMode,
  charityId: selectCharityId,
  charityName: selectSelectedCharityName,
  charityAddress: selectCharityAddress,
  csrBusinessFunction: selectCsrBusinessFunction,
  advisors: selectAdvisors,
  codeValueMappingData: mapData,
});
